import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Loader2 } from 'lucide-react';
import { getVendorPaymentCC } from '../../api/businessinfoAPI/vendorPOAPI';
import SPPOPayment from './SPPOPayment';
import VendorCashPayment from '../Accounts/VendorCashPayment';

// Legacy /Purchase/SPPOPayments is a single menu entry for both bank and cash vendor payments.
// PurchaseController.SPPOPayments picks the mode from GetVendorPaymentCC: BankAccess -> Bank,
// else CashAccess -> Cash (site accountant). Mirror that here instead of using a separate menu path.
const VendorPaymentEntry = ({ menuData }) => {
    const { userData } = useSelector((s) => s.auth);
    const roleId = userData?.roleId || userData?.RID || 0;
    const userId = userData?.userId || userData?.UID || userData?.employeeId || '';

    const [mode, setMode] = useState(null); // 'Bank' | 'Cash' | 'None'

    useEffect(() => {
        if (!roleId || !userId) return;
        let cancelled = false;
        getVendorPaymentCC(roleId, userId)
            .then((res) => {
                const access = res?.Data || res?.data || res || {};
                const bank = access.BankAccess ?? access.bankAccess;
                const cash = access.CashAccess ?? access.cashAccess;
                if (!cancelled) setMode(bank ? 'Bank' : cash ? 'Cash' : 'None');
            })
            .catch(() => { if (!cancelled) setMode('None'); });
        return () => { cancelled = true; };
    }, [roleId, userId]);

    if (mode === null) {
        return (
            <div className="flex items-center justify-center py-20 text-gray-500 dark:text-gray-400">
                <Loader2 className="w-5 h-5 mr-2 animate-spin" /> Loading payment access...
            </div>
        );
    }
    if (mode === 'Bank') return <SPPOPayment menuData={menuData} />;
    if (mode === 'Cash') return <VendorCashPayment menuData={menuData} />;
    return (
        <div className="py-20 text-center text-gray-500 dark:text-gray-400">
            You do not have bank or cash access for vendor payments.
        </div>
    );
};

export default VendorPaymentEntry;
